import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { FEEDBACK_RATING_SCALE } from "../feedback-question.utils";

@Component({
	selector: "app-feedback-rating-scale",
	templateUrl: "./feedback-rating-legend.component.html",
	styleUrls: ["./feedback-rating-legend.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class FeedbackRatingScaleComponent {
	@Input() selected: number | null = null;
	@Input() readonly = false;
	@Output() selectedChange = new EventEmitter<number>();

	readonly ratingScale = FEEDBACK_RATING_SCALE;

	choose(score: number): void {
		if (this.readonly) return;
		this.selectedChange.emit(score);
	}
}
